import React, { Component } from "react";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { Card, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import * as Common from "../CommonControlls/CommonJs";
import _ from "lodash";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: [],
        };
    }

    componentDidMount() {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {},
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter((p) => p.permissioN_ALLOWED)
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );
    }

    render() {
        return (
            <div>
                <MainLayout />
                <div id="right-panel" className="right-panel">
                    <Topmenu
                        PageTitle="Home"
                        isShowAddBtn={false}
                        AddBtnLabel=""
                        AddBtnLink=""
                    />
                    <div className="content">
                        <div className="d-flex justify-content-center my-4">
                            <h1 className="my-3">
                                <b>
                                    {" "}
                                    <span style={{ color: "#56c0f8" }}>Welcome to Riders</span>
                                    <span style={{ color: "red" }}> for Health </span>
                                </b>
                            </h1>
                        </div>
                        <Row>
                            <Col md={3}>
                                <Card style={{ background: "#c5e6f8" }}>
                                    <Card.Body>
                                        <Card.Text>
                                            <div class="mainlayoutlinks">
                                                <Link to="/Dashboard">
                                                    <span className="imageContainer d-flex justify-content-center">
                                                        <i
                                                            class="menu-icon fa fa-tachometer mainlayoutlinks"
                                                            style={{ fontSize: "40px", color: "red" }}
                                                        ></i>
                                                    </span>
                                                    <span
                                                        className="MenuLabelContainer d-flex justify-content-center"
                                                        style={{ color: "red" }}
                                                    >
                                                        Dashboard
                                                    </span>
                                                </Link>
                                            </div>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {this.state.permissions.includes("xpertsite-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Xpert_Sites">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-medkit mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Xpert Sites
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("heatmap") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Heat_Map">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-map-o mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Heat Map
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("dispute-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Dispute_List">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-exclamation-triangle mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Dispute
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            {this.state.permissions.includes("districtwisetargets-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/DistrictWise_Target">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-bullseye mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            District Wise Targets
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("hcfs-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/BHUAndRHC">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-hospital-o mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            HCFs (BHUs & RHCs)
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("bhusrhcscluster-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/BHUAndRHCClusters">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-building-o mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            BHUs & RHCs Cluster
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("patient-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Patients">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-wheelchair mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Patients
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            {this.state.permissions.includes("patientsamples-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Patient_Samples">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-flask mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Patient Samples
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>)}
                            {this.state.permissions.includes("jobhistory-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Jobs">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-briefcase mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Rider Jobs
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("qrcode") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Sample_QRCode_Printing">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-qrcode mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            QR Codes
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("users-view") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Users">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-users mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Users
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            {this.state.permissions.includes("activity") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Activity_List">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-cog mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Activity
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes("setting") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Settings">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-cogs mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Settings
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <h4 className="my-3">
                            <b>Geography</b>
                        </h4>
                        {!this.state.permissions.includes("province-view") &&
                            !this.state.permissions.includes("district-view") &&
                            !this.state.permissions.includes("tehsil-view") ? null : (
                            <Row>
                                {this.state.permissions.includes("province-view") && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/Province">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-map-signs mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                Province
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                                {this.state.permissions.includes("subrecipient-view") && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/SubRecipient_List">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-list mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                Sub Recipient
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                                {this.state.permissions.includes("district-view") && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/Districts">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-map-marker mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                Districts
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                                {this.state.permissions.includes("tehsil-view") && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/Tehsil">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-globe mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                Tehsil
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                        )}
                        {this.state.permissions.includes("roles-view") && <>
                            <h4 className="my-3">
                                <b>Roles</b>
                            </h4>
                            <Row>
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Roles">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-lock  mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Role Types
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/Administrators">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-shield mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            Administrators
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </>}
                        <h4 className="my-3">
                            <b>Reports</b>
                        </h4>
                        <Row>
                            {this.state.permissions.includes(
                                "st_progress_report_Province"
                            ) && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/Province_Report">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-map-signs mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                Province
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                            {this.state.permissions.includes("st_progress_report_sr") && (
                                <Col md={3}>
                                    <Card style={{ background: "#c5e6f8" }}>
                                        <Card.Body>
                                            <Card.Text>
                                                <div class="mainlayoutlinks">
                                                    <Link to="/SR_Report">
                                                        <span className="imageContainer d-flex justify-content-center">
                                                            <i
                                                                class="menu-icon fa fa-database mainlayoutlinks"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            ></i>
                                                        </span>
                                                        <span
                                                            className="MenuLabelContainer d-flex justify-content-center"
                                                            style={{ color: "red" }}
                                                        >
                                                            SR
                                                        </span>
                                                    </Link>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {this.state.permissions.includes(
                                "st_progress_report_district"
                            ) && (
                                    <Col md={3}>
                                        <Card style={{ background: "#c5e6f8" }}>
                                            <Card.Body>
                                                <Card.Text>
                                                    <div class="mainlayoutlinks">
                                                        <Link to="/District_Report">
                                                            <span className="imageContainer d-flex justify-content-center">
                                                                <i
                                                                    class="menu-icon fa fa-map-marker  mainlayoutlinks"
                                                                    style={{ fontSize: "40px", color: "red" }}
                                                                ></i>
                                                            </span>
                                                            <span
                                                                className="MenuLabelContainer d-flex justify-content-center"
                                                                style={{ color: "red" }}
                                                            >
                                                                District
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(Home);
